import { Component, ViewEncapsulation } from '@angular/core';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
    selector: 'tidy-add-direct-integration-onboarding',
    templateUrl: './add-direct-integration-onboarding.component.html',
    styleUrls: ['./add-direct-integration-onboarding.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class AddDirectIntegrationOnboardingComponent {
  constructor(public windowService: WindowService) {}
} 



